<template>
    <PurchaseOrderEntry></PurchaseOrderEntry>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const PurchaseOrderEntry = defineAsyncComponent(() =>
    import(
        "../../components/Purchasing/PurchaseOrderEntry/PurchaseOrderEntry.vue"
    )
);

export default {
    name: "PurchaseOrderEntry_Purchashing",
    components: { PurchaseOrderEntry, AuthLayout },
};
</script>
